import Login from './Login'
import ForgotPassword from './ForgotPassword'
// import Register from './Register';

export default {
  Login,
  ForgotPassword
  // Register,
}



// WEBPACK FOOTER //
// ./src/components/pages/auth/index.js